function reducer(state: any, action: any): any {
  switch (action.type) {
    case "success": {
      return {
        ...state,
        notifier: {
          isOpen: true,
          status: "success",
          title: action.title || "Success!",
          description: action.description || ""
        }
      };
    }
    case "error": {
      return {
        ...state,
        notifier: {
          isOpen: true,
          status: "error",
          title: action.title || "Something went wrong",
          description: action.description || ""
        }
      };
    }
    case "info": {
      return {
        ...state,
        notifier: {
          isOpen: true,
          status: "info",
          title: action.title || "Information",
          description: action.description || ""
        }
      };
    }

    case "close": {
      return {
        ...state,
        notifier: {
          ...state.notifier,
          isOpen: false
        }
      };
    }

    case "loading": {
      return {
        ...state,
        loading: action.value
      };
    }

    case "server_error": {
      return {
        ...state,
        error: action.value
      };
    }

    case "open_notes_modal": {
      return {
        ...state,
        notesModal: {
          openModal: true,
          userAssessmentCycleId: action.userAssessmentCycleId,
          userAssessmentId: action.userAssessmentId,
          refetch: action.refetch,
          noteId: action.noteId,
          userAssessment: action.userAssessment,
          noteText: action.noteText
        }
      };
    }

    case "close_notes_modal": {
      return {
        ...state,
        notesModal: {
          openModal: false,
          userAssessmentCycleId: undefined,
          userAssessmentId: undefined,
          refetch: undefined
        }
      };
    }

    case "set_role": {
      return {
        ...state,
        role: action.value
      };
    }
    default:
      return state;
  }
}

export default reducer;
